import React from 'react';
import { Checkbox, withStyles } from "@material-ui/core";

const SMCheckBox = withStyles({
    root: {
      '&$checked': {
        color: '#2680EB',
      },
    },
    checked: {},
  })((props) => <Checkbox color='default' {...props} />);

export default SMCheckBox